import { watchEffect, toValue, type MaybeRefOrGetter } from 'vue'

export function usePageTitle(title: MaybeRefOrGetter<string | undefined>) {
  watchEffect(() => {
    const t = toValue(title)
    
    document.title = t ? `${t} | Drivalia eOrders` : 'Drivalia - eOrders'
  })
}